import { Drawer } from '@base-ui/react/drawer';

import { useUserAccount } from '@/shared/design-system/components/UserDropdown/use-user-account';
import { UserAccountContent } from '@/shared/design-system/components/UserDropdown/user-account-content';

import { BottomSheetBackdrop, BottomSheetPopup } from './MobileHeader.styled';

type Props = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  data: ReturnType<typeof useUserAccount>;
};

export const UserAccountDrawer = ({ open, onOpenChange, data }: Props) => (
  <Drawer.Root open={open} onOpenChange={onOpenChange} swipeDirection="down" modal>
    <Drawer.Portal>
      <BottomSheetBackdrop />
      <BottomSheetPopup>
        <UserAccountContent data={data} onClose={() => onOpenChange(false)} />
      </BottomSheetPopup>
    </Drawer.Portal>
  </Drawer.Root>
);
